import { Component, Injectable, ElementRef } from '@angular/core';
// import * as $ from 'jquery';
import { interActivityServices } from '../../shared/services/interactivity.services';
import { AudioControllerComponent } from '../../shell/audio_controller/audio_controller.component';
import { SliderControllerComponent } from '../../shell/slider_controller/slider_controller.component';
import * as activityDataObj from '../../shared/content/activityData.json';


declare var $: any;

@Injectable()
@Component({
  selector: 'app-interactivity',
  templateUrl: './interactivity.component.html',
  styleUrls: ['./interactivity.component.css']
})

export class InteractiveComponent {
  public commonData = (<any>activityDataObj).commonData;
  public activityData = (<any>activityDataObj).activityData;
  public observTime;
  public clickCounter = 0;
  constructor(
    public sliderCompo: SliderControllerComponent,
    public activityServices: interActivityServices,
    public audioController: AudioControllerComponent,
  ) {
    let self = this;
    document.addEventListener('videoValuechanged', function (event) {
      let videoTime = (<any>event).time;
      if (self.activityData.videoTimeline[0].text) {
        //self.activityServices.videoTimelineTxt = self.activityData.videoTimeline[0].text;
        let timeLineObj = self.getCurrentTimeObj(videoTime)
        if (timeLineObj && timeLineObj.text) {
          // console.log(videoTime, timeLineObj);
          self.activityServices.videoTimelineTxt = timeLineObj.text;
          $('#spanTimeline').html(self.activityServices.videoTimelineTxt)
        }
      }
      if (videoTime > 43.9) {
        $('#nextButton').addClass('disabledBtn')
      }
    });
  }
  ngAfterViewInit() {

    // if (!$('.resetBtnWrapper').hasClass('disabledReset')) {
    //   $("#resetButton").attr("tabindex", -1)
    // }
  }
  getCurrentTimeObj(_vTime): any {
    let videoTimelineObj = this.activityData.videoTimeline;
    for (let i in videoTimelineObj) {
      if (videoTimelineObj[i].time >= _vTime && !this.activityServices.isShowPlay) {
        return videoTimelineObj[i];
      }
    }
  }

  prevNextClick(event, action) {
    if (event.type == "click" || (event.type == "keydown" && event.keyCode == 13 || event.keyCode == 32)) {

      if (action === 'previous') {
        this.clickCounter--;

        $('#nextButton').removeClass('disabledBtn')
        $('#nextButton').attr('tabindex', 0)
        if (this.activityServices.isVideoEnded) {
          this.activityServices.isShowPlay = false;
          $('.playBtnWrapper').removeClass('disabledPlayPause')
          $('#nextButton').removeClass('disabledBtn')
        }
        this.activityServices.pauseVideo()
        let cTime = (this.activityServices.videoElement.currentTime)
        let vidObject = this.activityData.videoTimeline;

        for (let i = 0; i < vidObject.length; i++) {
          if (cTime < vidObject[i].time) {
            this.activityServices.videoElement.currentTime = vidObject[i - 1].prevTime;
            $('#spanTimeline').html(vidObject[i - 1].text);
            break;
          }
        }
        this.activityServices.isShowPlay = false;
        this.activityServices.playVideo()
      }// if closed
      else {
        this.clickCounter++
        this.activityServices.pauseVideo()
        let cTime = (this.activityServices.videoElement.currentTime)
        let vidObject = this.activityData.videoTimeline;
        for (let i = 0; i < vidObject.length; i++) {
          if (cTime < vidObject[i].startTime) {
            this.activityServices.videoElement.currentTime = vidObject[i].startTime;
            $('#spanTimeline').html(vidObject[i].text);
            if (this.activityServices.videoElement.currentTime > 39.2) {
              $('#nextButton').addClass('disabledBtn')
            }
            break;
          }
        }
        this.activityServices.isShowPlay = false;
        this.activityServices.playVideo()
      } // else closed.
      if (this.clickCounter == 0) {
        $('#prevButton').attr('tabindex', -1)
        $('#nextButton').attr('tabindex', 0)
      }
      else if (this.clickCounter == 1 && this.clickCounter <= 5) {
        $('#nextButton,#prevButton').attr('tabindex', 0)
      }
      else if (this.clickCounter == 5) {
        $('#prevButton').attr('tabindex', 0)
        $('#nextButton').attr('tabindex', -1)
      }
    }
  }
}
